import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Dialog,
  DialogHeader,
  Typography,
  IconButton,
  DialogBody,
  Button,
} from '@material-tailwind/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useCallback, useEffect } from 'react';
import ListaLocaisApc from '../../components/Listas/ListaLocaisApc';
import { getProdutoInEquipamento } from '../../slices/productSlice';

import { List } from '@material-tailwind/react';
import ListItemInfo from '../Listas/ListItemInfo';
import { convertToInt } from '../../hook/convertQuantidade';
import { colorApclition } from '../../pages/Produto/ListInfo';

const ListInfo = ({ produto }) => {
  const colorApclition = (color) => {
    switch (color) {
      case 'Descontinio':
        return 'bg-gray-500 p-1 rounded-lg text-black text-center ';
      case 'Estoque':
        return 'bg-green-300 p-1 rounded-lg text-end  text-center ';
      case 'Direta':
        return 'bg-red-500 p-1 rounded-lg  text-center';
    }
  };
  const textMarcs = useCallback(() => {
    const marcas = produto.marcaDeCompra.map((marca) => marca.nome);
    return marcas ? marcas.join(', ') : '';
  }, [produto]);
  return (
    <List className="sm:grid md:grid-cols-2 lg:grid-cols-3 gap-4 w-full auto-rows-[100px] text-black dark:text-white ">
      <ListItemInfo title="Winthor" text={produto?.winthor} />
      <ListItemInfo
        title="Quantidade"
        text={produto?.quantidade_total && convertToInt(produto.quantidade_total)}
      />

      <ListItemInfo title="Endereço" text={produto?.endereco} />
      {produto?.categoriaCompra && (
        <>
          <ListItemInfo title="Marcas" text={produto?.marcaDeCompra ? textMarcs(produto) : ''} />
          <ListItemInfo title="Categoria Compra" text={produto?.categoriaCompra} />
          <ListItemInfo title="Categoria" text={produto?.categoria.nome} />
        </>
      )}
      <div className="absolute"></div>
      <div className="col-span-2 grid grid-cols-2 gap-2">
        {produto?.ultima_entrada && (
          <ListItemInfo
            title="Ultima entrada"
            text={produto?.ultima_entrada}
            cssContainer="border-green-500 mt-2"
          />
        )}
        {produto?.ultima_saida && (
          <ListItemInfo
            title="Ultima saida"
            text={produto?.ultima_saida}
            cssContainer="border-red-500 mt-2"
          />
        )}
      </div>
      <div className="absolute"></div>
    </List>
  );
};

export const ProdutoModalInfo = ({ produto, handleProduto }) => {
  const dispatch = useDispatch();
  const id = produto.winthor;
  const { inequip } = useSelector((state) => state.product);

  useEffect(() => {
    if (id) {
      dispatch(getProdutoInEquipamento(id));
    }
  }, []);

  return (
    <>
      <Dialog
        open={!!produto}
        handler={handleProduto}
        size="lg"
        className={`p-0  bg-gray-400 dark:bg-none  dark:bg-darkColorBg max-h-[90vh] overflow-auto  global-scrollbar min-h-[80vh]`}
      >
        <DialogHeader className="relative m-0 block overflow-hidden bg-lightMenu dark:bg-black/20">
          <Typography variant="h4" className="dark:text-darkText text-white">
            {produto?.nome}
          </Typography>
          <Typography
            variant="h6"
            className="dark:text-darkText text-white uppercase font-light mt-2 "
          >
            {produto?.descricao}
          </Typography>

          <IconButton
            size="sm"
            variant="text"
            color="white"
            className="!absolute right-3.5 top-3.5"
            onClick={handleProduto}
          >
            <XMarkIcon className="h-5 w-5 stroke-2 text-white dark:text-darkText " />
          </IconButton>
        </DialogHeader>
        <DialogBody className="">
          <div className="w-full sm:flex gap-2 ">
            <div className="basis-[40%] flex flex-col lg:justify-center lg:items-center gap-y-2">
              <div className="w-full">
                <img
                  src={produto?.foto || '/img/not-img.png'}
                  className="object-contain w-full max-h-[300px]"
                  alt=""
                />
              </div>
              {produto?.lastPreco && (
                <div
                  className={`${
                    produto?.tipoEstoque ? colorApclition(produto.tipoEstoque) : ''
                  } flex flex-col items-center p-3 rounded-[15px] w-[80%] justify-center`}
                >
                  <Typography variant="h1" color="white">
                    {produto?.lastPreco ? `R$ ${produto.lastPreco}` : '--------'}
                  </Typography>
                  <Button variant="outlined" className="bg-white/20 ">
                    {produto?.tipoEstoque}
                  </Button>
                </div>
              )}
            </div>
            <div className="flex  basis-[60%]">
              <ListInfo produto={produto} />
            </div>
          </div>
          <div className="w-full flex justify-between sm:justify-end sm:items-end gap-5 bottom-0 right-4 text-black mt-2">
            {produto?.ultima_entrada && (
              <Link to={`/historico/entradas/?historico=${id}`}>
                <Button
                  className="font-bold italic dark:text-cyan-200   hover:text-green-300 "
                  color="green"
                >
                  Historico de entrada
                </Button>
              </Link>
            )}
            {produto?.ultima_saida && (
              <Link to={`/historico/saida/?historico=${id}`}>
                <Button
                  className="font-bold italic  dark:text-cyan-200   hover:text-green-300 bg-red-500"
                  variant="gradient"
                  color="red"
                >
                  Historico de saida
                </Button>
              </Link>
            )}
          </div>
          <div>
            <div>
              <Typography
                variant="h5"
                className="text-center pb-1 italic text-black dark:text-white "
              >
                Locais de aplicaçao
              </Typography>
              <div className="overflow-auto ">
                <ListaLocaisApc item={inequip} />
              </div>
            </div>
          </div>
        </DialogBody>
      </Dialog>
    </>
  );
};
